/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SharedContactDealerWrapper_user$ref = any;
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type PdpSharedMakeOfferButton_user$ref = any;
export type PdpSharedMakeOfferButton_user = {
    readonly profile: {
        readonly currency: Currency | null;
    } | null;
    readonly " $fragmentRefs": SharedContactDealerWrapper_user$ref;
    readonly " $refType": PdpSharedMakeOfferButton_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedMakeOfferButton_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "currency",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user",
      "args": null
    }
  ]
};
(node as any).hash = '6566dfb682a0449e8b6d43ffa64a5175';
export default node;
